import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "close", "trending"]

  connect() {
    this.beforeCacheHandler = this.prepareCache.bind(this)
    this.pageshowHandler = this.syncFromFocus.bind(this)
    document.addEventListener("turbo:before-cache", this.beforeCacheHandler)
    window.addEventListener("pageshow", this.pageshowHandler)
    this.syncFromFocus()
    requestAnimationFrame(() => this.syncFromFocus())
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCacheHandler)
    window.removeEventListener("pageshow", this.pageshowHandler)
  }

  open() {
    this.showClose()
    if (this.hasTrendingTarget) this.trendingTarget.hidden = false
  }

  close(event) {
    if (event) event.preventDefault()
    this.reset()
    if (this.hasInputTarget) this.inputTarget.blur()
  }

  syncFromFocus() {
    window.requestAnimationFrame(() => {
      if (this.hasInputTarget && document.activeElement === this.inputTarget) {
        this.open()
        return
      }

      this.hideClose()
      if (this.hasTrendingTarget) this.trendingTarget.hidden = true
    })
  }

  prepareCache() {
    this.reset()
  }

  reset() {
    this.hideClose()
    if (this.hasTrendingTarget) this.trendingTarget.hidden = true
    if (this.hasInputTarget) this.inputTarget.value = ""
  }

  showClose() {
    if (this.hasCloseTarget) this.closeTarget.hidden = false
  }

  hideClose() {
    if (this.hasCloseTarget) this.closeTarget.hidden = true
  }
}
